/** LLM providers shown in create/edit project UI (disabled entries sort last). */

/** Not shown in create/edit project UI (use Ollama for Qwen models). */
export const HIDDEN_LLM_PROVIDER_IDS = ['qwen'];

export const DISABLED_LLM_PROVIDERS = [
  { id: 'vllm', label: 'vLLM', disabled: true, description: 'High-throughput LLM serving (not available yet).' },
  { id: 'gemini', label: 'Gemini', disabled: true, description: 'Google Gemini models (not available yet).' },
  { id: 'azure', label: 'Azure OpenAI', disabled: true, description: 'Azure OpenAI Service models (not available yet).' },
];

const disabledById = () =>
  Object.fromEntries(DISABLED_LLM_PROVIDERS.map((p) => [p.id, p]));

/**
 * Merge catalog providers with UI-disabled overrides; enabled providers first.
 */
export function mergeLlmProvidersForUi(catalogProviders, fallback = [{ id: 'openai', label: 'OpenAI' }]) {
  const disabledMap = disabledById();
  const merged = new Map();

  for (const p of catalogProviders?.length ? catalogProviders : fallback) {
    if (HIDDEN_LLM_PROVIDER_IDS.includes(p.id)) continue;
    const dis = disabledMap[p.id];
    merged.set(
      p.id,
      dis ? { ...p, ...dis, disabled: true } : { ...p, disabled: !!p.disabled },
    );
  }
  for (const dis of DISABLED_LLM_PROVIDERS) {
    if (HIDDEN_LLM_PROVIDER_IDS.includes(dis.id)) continue;
    if (!merged.has(dis.id)) {
      merged.set(dis.id, dis);
    }
  }

  return [...merged.values()].sort(
    (a, b) => Number(!!a.disabled) - Number(!!b.disabled),
  );
}
